import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2126f058"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "container" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('스타트업 정보,\n누구보다 빠르게 '))
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 경험해보세요 ")
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/assets/image/pre_application.png",
  srcset: "/assets/image/pre_application.png 1x, /assets/image/pre_application@2x.png 2x, /assets/image/pre_application@3x.png 3x"
}, null, -1))
const _hoisted_5 = {
  class: "white-margin",
  style: {"margin-bottiom":"60px"}
}
const _hoisted_6 = { class: "home_top" }
const _hoisted_7 = { class: "title_22B" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 전체회사 ")
const _hoisted_9 = { class: "title_22R" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "main_16R" }, " 나와 함께 성장할 미래의 유니콘을 찾아보세요 ", -1))
const _hoisted_11 = { class: "row vote_row" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "space-between" }
const _hoisted_14 = { class: "entire_company_left" }
const _hoisted_15 = { class: "c_logo" }
const _hoisted_16 = ["src"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inset-border" }, null, -1))
const _hoisted_18 = { class: "entire_company_right" }
const _hoisted_19 = { class: "list_17M" }
const _hoisted_20 = { class: "right_bottom" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "small_leaf_g leaf_g",
  src: "/assets/icon/small_leaf_g.png"
}, null, -1))
const _hoisted_22 = { class: "green" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "·", -1))
const _hoisted_24 = { style: {"margin":"0px 8px","color":"#D9DEE8","font-size":"10px"} }
const _hoisted_25 = {
  key: 0,
  class: "charcoal"
}
const _hoisted_26 = {
  key: 1,
  class: "charcoal"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "더보기", -1))
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" (주)엔젤리그")
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 대표이사 오현석 / support@capbox.kr")
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 서울특별시 강남구 선릉로 158길 7, 4층(청담동)")
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 사업자 등록번호 705-87-01352")
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 통신판매번호 2021-서울강남-03485")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Copyright © Angel League, Inc. All rights reserved.")
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1))
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1))
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " | ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ag_refresher = _resolveComponent("ag-refresher")!
  const _component_ag_text_s = _resolveComponent("ag-text-s")!
  const _component_ag_box_s = _resolveComponent("ag-box-s")!
  const _component_popular_share_transaction_modal = _resolveComponent("popular-share-transaction-modal")!
  const _component_new_board_list = _resolveComponent("new-board-list")!
  const _component_ion_ripple_effect = _resolveComponent("ion-ripple-effect")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { ref: "mainElement" }, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ag_refresher, {
            slot: "fixed",
            onRefresh: _ctx.doRefresh
          }, null, 8, ["onRefresh"]),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ag_box_s, { css: {bg: 'primary', py: 24, dp: 'flex', direction: 'column'} }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_box_s, { css: {px: 20} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ag_text_s, { css: {whiteSpace: 'pre', color: 'white', fontWeight: 800, fontSize: '26px', lineHeight: '32px'} }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ag_text_s, { css: {color: 'white', fontWeight: 400, fontSize: '26px', lineHeight: '32px'} }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_box_s, { css: {maxWidth: 375} }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_popular_share_transaction_modal, {
              "model-value": _ctx.viewShareTransactionOpen,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = (value) => _ctx.viewShareTransactionOpen = value),
              onCompanyClick: _cache[1] || (_cache[1] = ($event) => _ctx.useCompanyModal($event, 'share-sell'))
            }, null, 8, ["model-value"]),
            _createVNode(_component_new_board_list, {
              parent: "home",
              "stock-item-boards-prop": _ctx.stockItemBoards
            }, null, 8, ["stock-item-boards-prop"]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.stockItems.length), 1)
                ]),
                _hoisted_10
              ]),
              _createElementVNode("div", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stockItems10, (stock) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: stock.stockItemId,
                    class: "ion-activatable ripple-parent entire_company",
                    onClick: ($event: any) => (_ctx.useCompanyModal(stock.stockItemId))
                  }, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("img", {
                            src: stock.companyLogo ? stock.companyLogo : '/assets/icon/company_default_img.png',
                            onerror: "this.src='/assets/icon/company_default_img.png'",
                            class: "img-responsive img-circle"
                          }, null, 8, _hoisted_16),
                          _hoisted_17
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(stock.stockItemName), 1),
                          _createElementVNode("div", _hoisted_20, [
                            _hoisted_21,
                            _createElementVNode("span", _hoisted_22, _toDisplayString(Number(stock.avgPoint).toFixed(1)), 1),
                            _hoisted_23,
                            _createElementVNode("span", null, _toDisplayString(stock.count) + "명", 1),
                            _withDirectives(_createElementVNode("span", _hoisted_24, "|", 512), [
                              [_vShow, stock.minSellingPrice !== null]
                            ]),
                            (stock.minSellingPrice === null)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_25))
                              : (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$filters.currency(stock.minSellingPrice)) + " 원", 1))
                          ])
                        ])
                      ])
                    ])
                  ], 8, _hoisted_12))
                }), 128))
              ]),
              _createElementVNode("button", {
                class: "ion-activatable ripple-parent add_btn main_14R",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openItemEntireModal()))
              }, [
                _hoisted_27,
                _createVNode(_component_ion_ripple_effect, { type: "unbounded" })
              ])
            ]),
            _createVNode(_component_ag_box_s, { css: {p: '32px 20px', bg: 'black', lineHeight: '20px'} }, {
              default: _withCtx(() => [
                _createVNode(_component_ag_text_s, { css: {typography: 'main12r', color: 'white'} }, {
                  default: _withCtx(() => [
                    _hoisted_28,
                    _hoisted_29,
                    _hoisted_30,
                    _hoisted_31,
                    _hoisted_32,
                    _hoisted_33,
                    _hoisted_34,
                    _hoisted_35,
                    _hoisted_36,
                    _hoisted_37
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_text_s, { css: {dp: 'black', typography: 'main12r', color: 'gray3'} }, {
                  default: _withCtx(() => [
                    _hoisted_38,
                    _hoisted_39
                  ]),
                  _: 1
                }),
                _createVNode(_component_ag_text_s, { css: {typography: 'main12r', color: 'white'} }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'footer', 'clickContent':'FAQ'});_ctx.openFAQModal('FAQ')})
                    }, "FAQ "),
                    _hoisted_40,
                    _createElementVNode("span", {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'footer', 'clickContent':'회사소개'});_ctx.openFAQModal('info')})
                    }, " 회사소개 "),
                    _hoisted_41,
                    _createElementVNode("span", {
                      onClick: _cache[5] || (_cache[5] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'footer', 'clickContent':'이용약관'});_ctx.openLink('https://www.notion.so/angelleague/03d3a6fa9e0e41bb864d8289720bc52b')})
                    }, " 이용약관 "),
                    _hoisted_42,
                    _createElementVNode("span", {
                      onClick: _cache[6] || (_cache[6] = ($event: any) => {_ctx.$clickTrackEvent({clickScreen: _ctx.clickScreen,'clickArea':'footer', 'clickContent':'개인정보처리방침'});_ctx.openLink('https://www.notion.so/angelleague/cd4f32d98c4142f0858478c16de78c2f')})
                    }, " 개인정보처리방침 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}